export const COMPANY_PROFILE = {
  legalName: 'Swarvinn Impex Ltd',
  tradingName: 'Swarvinn Impex',
  tagline: 'Global Trade. Trusted Quality.',
  founded: '2018',
  headquarters: 'Tamil Nadu, India',
  primaryMarket: 'United Kingdom',
  secondaryMarkets: [
    'Europe',
    'UAE & Middle East',
    'USA',
    'Canada',
    'Australia',
    'Singapore',
  ],
  /** @deprecated use primaryMarket + secondaryMarkets */
  markets: ['United Kingdom', 'Europe', 'UAE & Middle East', 'USA', 'Canada', 'Australia', 'Singapore'],
  businessType: 'Food & Grocery Export House',
  registration: 'Registered Indian Export Company',
};

export const COMPANY_OVERVIEW = {
  headline: 'Exporting authentic Indian groceries from Tamil Nadu — with the United Kingdom as our main market.',
  intro: [
    'Swarvinn Impex Ltd is a Tamil Nadu-based export house specialising in wholesale supply of authentic Indian food products. Our main export country is the United Kingdom, where we serve wholesalers, cash & carry operators, Asian supermarkets, restaurant suppliers, and independent retailers with dependable India-to-UK import support.',
    'Alongside the UK, we also supply secondary markets across Europe, the UAE & Middle East, USA, Canada, Australia, and Singapore. From our South India sourcing network we procure premium rice, spices, pulses, millets, flours, oils, pickles, snacks, and traditional staples — graded, packed, and documented for international trade.',
  ],
  mission:
    'To connect food businesses with trusted Indian producers through transparent sourcing, export-grade quality control, and reliable logistics — with the United Kingdom as our primary focus and selected other countries as secondary markets.',
  vision:
    'To become the preferred India export partner for wholesale grocery import into the UK, while supporting growing demand in Europe, the Middle East, North America, Australia, and Singapore.',
};

export const COMPANY_STATS = [
  { value: '100+', label: 'Export SKUs' },
  { value: 'UK', label: 'Main Export Country' },
  { value: '50kg', label: 'Wholesale MOQ' },
  { value: '6+', label: 'Secondary Markets' },
];

export const CORE_VALUES = [
  {
    title: 'Quality First',
    desc: 'Every batch is inspected, cleaned, and graded to international export standards before packing.',
  },
  {
    title: 'UK First, Global Reach',
    desc: 'Products, labelling, and packing prepared for the UK trade first — with flexible supply for other countries on request.',
  },
  {
    title: 'Transparent Sourcing',
    desc: 'Direct procurement from trusted farms and mills across Tamil Nadu and South India.',
  },
  {
    title: 'Compliance Ready',
    desc: 'FSSAI certified products with full export documentation, commodity codes, and certificates of origin.',
  },
];

export const CERTIFICATIONS = [
  'FSSAI Certified Products',
  'Export-Grade Quality Control',
  'Phytosanitary Documentation',
  'Certificates of Origin',
  'UK HMRC Commodity Codes',
  'Vacuum & Export Packing Standards',
];

export const EXPORT_SERVICES = [
  {
    icon: 'package',
    title: 'Wholesale Supply',
    desc: 'Bulk rice, spices, pulses, and staples for UK depots, cash & carry, and food distributors — plus secondary markets worldwide.',
  },
  {
    icon: 'tag',
    title: 'Private Label',
    desc: 'Custom branding, re-labelling, and packaging formats suited to UK shelf requirements and other destination markets.',
  },
  {
    icon: 'box',
    title: 'Flexible Packing',
    desc: 'From 50g retail packs to bulk sacks — vacuum sealed and export graded for long-haul transit.',
  },
  {
    icon: 'ship',
    title: 'Freight Coordination',
    desc: 'Primary sea freight to UK ports (Felixstowe, Southampton, London Gateway); routes to Europe, Middle East, and other markets on request.',
  },
];

export const COMPANY_DETAILS = [
  { label: 'Legal Name', value: 'Swarvinn Impex Ltd' },
  { label: 'Business Type', value: 'Food & Grocery Export House' },
  { label: 'Headquarters', value: 'Tamil Nadu, India' },
  { label: 'Main Export Country', value: 'United Kingdom' },
  { label: 'Secondary Markets', value: 'Europe, UAE & Middle East, USA, Canada, Australia, Singapore' },
  { label: 'Product Range', value: 'Rice, spices, pulses, millets, flours, oils & specialty groceries' },
  { label: 'Wholesale MOQ', value: '50 kg per product' },
  { label: 'Packing Options', value: '50g retail to bulk sacks — vacuum packed & private label' },
  { label: 'Freight', value: 'Sea freight to UK ports first; other countries on request; air freight available' },
  { label: 'Established', value: '2018' },
];

export const CONTACT_DETAILS = {
  address: 'Swarvinn Impex, Export Division, Tamil Nadu, India — Main market: United Kingdom',
  phone: '+91 442 234 5678',
  email: 'export@swarvinnimpex.com',
};

export const ABOUT_IMAGES = {
  hero: '/images/about-company-hero.png',
  story: '/images/about-company-story.png',
};
